// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"8dd0c07b","87":"1a66f9dc","418":"e3b37d12","453":"6fa2e2be","800":"23a7031c"}[chunkId] + ".chunk.js";
};